// FLAGS: none
// Renders the Spaces Schedules page only while the AdminSpacesSchedules flag is on (OI-26005). Off, or unreadable, sends
// the expert to the dashboard home, so a bookmark or an older Slack link never shows the page before launch.
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS } from "@src/constants";
import { useFeatureFlagQuery } from "@src/queries/featureflags";

interface SpacesSchedulesGateProps {
  /** The page; one element, rendered as is. */
  children: ReactElement;
}

const SpacesSchedulesGate = ({ children }: SpacesSchedulesGateProps) => {
  const {
    data: enabled,
    isPlaceholderData,
    isError,
  } = useFeatureFlagQuery(FEATURE_FLAGS.ADMIN_SPACES_SCHEDULES);

  // Until the flag is read, render nothing: neither flash the page nor bounce the expert away.
  if (isPlaceholderData && !isError) return null;
  if (!enabled) return <Navigate to="/" replace />;
  return children;
};

export default SpacesSchedulesGate;
